<template>
    <div class="accordion3 accordion_box">
        <div @click="is_active=!is_active">{{key_name}}&nbsp;<span class="open_mark">▼</span></div>
        <div style="padding-left: 1rem;"
             class="style_button"
             v-bind:class="{accordion_onoff:is_active}"
             v-for="(style_data, index) in $store.state.xlsx_data.style_group2_data[category][key_name]"
        >
            <input type="radio"
                   v-bind:id="'style_'+style_data.style_id"
                   v-model="style_selected"
                   v-bind:value="style_data.style_id"
                   v-bind:disabled="$store.state.search_data[style_data.style]=='×'"
            >
<!--            {{$store.state.search_data[style_data.style]}}:-->
            <label style="margin: 0 0 0.1rem 0.3rem;"
                   v-bind:for="'style_'+style_data.style_id"
                   v-bind:class="{disabled_label:$store.state.search_data[style_data.style]=='×'}"
                   v-on:click="no_select_rule(style_data.style,$store.state.search_data)"
            >
<!--                <span class="svg_icon" v-html="svg_html[style_data.svg]"></span>-->
                <img v-if="style_data.svg===undefined" class="svg_icon" v-bind:src="[style_selected==style_data.style_id ? './assets/images/blank_o.svg' : './assets/images/blank.svg']">
                <img v-else class="svg_icon" v-bind:src="[style_selected===style_data.style_id ? './assets/images/'+style_data.svg+'_o.svg' : './assets/images/'+style_data.svg+'.svg']">
                <p class="style_name">{{style_data.name}}</p>
<!--                <p class="style_name">{{style_data.style}}</p>-->
            </label>
        </div>

        <div
                v-if="key_name==='ローマンシェード ツイン' && group2 ==='ローマンシェード ツイン'"
                v-bind:class="{accordion_onoff:is_active}"
        >
            <div style="font-size: 0.8rem; margin: 1rem 0.5rem 0.5rem 0.5rem; ">後幕品番を入力する</div>
            <div>
                <p style="float: left;">&nbsp;&nbsp;&nbsp;&nbsp;FF&nbsp;&nbsp;
                <b-form-input type="number" pattern="\d*" style="width: 130px;" class="input_item_number" @keydown.enter="trigger" id="number_text" v-model="atomaku_number" v-on:keyup="checkItemNumber()" placeholder="後幕品番"></b-form-input>
                </p>
<!--                &nbsp;&nbsp;<b-button style="display:" v-on:click="checkItemNumber()" class="search_btn" variant="success">検索</b-button>-->
                <p style="font-size: 0.8rem; float: left; margin: 1rem 0; 0 0;">&nbsp;&nbsp;{{message}}</p>
<!--                <p style="color:red;font-size: 0.8rem; margin:1rem 0;">{{atomaku_error_message}}</p>-->
                <p style="clear: both; margin-bottom: 0px;"></p>
                <div v-if="$store.state.xlsx_data.item_data['FF'+atomaku_number]">
                    <p style="font-size: 0.8rem; margin : 0.5rem 0 0.5rem 0.5rem;">スタイルを選択する</p>
<!--                    <b-form-select v-model="atomaku_style_selected"-->
<!--                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['後幕スタイルを選ぶ'].option"></b-form-select>-->
                    <div style="clear: both; padding-left: 1rem;"
                         class="style_button"
                         v-for="(value, index) in atomaku_options"
                    >
                        <input type="radio"
                               v-bind:id="'atomaku_'+index"
                               v-model="atomaku_style_selected"
                               v-bind:value="value.text"
                               v-bind:disabled="$store.state.xlsx_data.item_data['FF'+atomaku_number] && $store.state.xlsx_data.item_data['FF'+atomaku_number][value.code]=='×'"
                        >
                        <!--            {{$store.state.search_data[style_data.style]}}:-->
                        <label style="margin: 0 0 0.1rem 0.3rem;"
                               v-bind:for="'atomaku_'+index"
                               v-bind:class="{disabled_label:$store.state.xlsx_data.item_data['FF'+atomaku_number] && $store.state.xlsx_data.item_data['FF'+atomaku_number][value.code]=='×'}"
                               v-on:click="no_atomaku_select_rule(value.code,$store.state.xlsx_data.item_data['FF'+atomaku_number])"
                        >
                            <!--                <span class="svg_icon" v-html="svg_html[style_data.svg]"></span>-->
                            <img class="svg_icon" v-bind:src="[atomaku_style_selected===value.text ? './assets/images/'+value.value+'_o.svg' : './assets/images/'+value.value+'.svg']">
                            <p class="style_name">{{value.text}}</p>
<!--                            <p>$store.state.search_data[value.code]</p>-->
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accordion3",
        props: {
            category: String,
            key_name: String,
        },
        data() {
            return {
                svg_html:{},
                is_active:true,
                message:'',
                atomaku_number:''
            }
        },
        created : function(){
        },
        watch: {
            /**
             * 全角→半角
             * @param v
             */
            atomaku_number : function(v) {
                this.atomaku_number = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
            },
            // item_data:function(value){
            //     if(this.atomaku_style_selected === ''){
            //         this.atomaku_style_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕スタイルを選ぶ'].option[0].value
            //     }
            // },
            // atomaku_style_selected:function(value){
            //     if(this.atomaku_style_selected === '' &&
            //         this.$store.state.step2_data.style_selected2_id &&
            //         this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2 ==='ローマンシェード ツイン' &&
            //     ){
            //         this.atomaku_style_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕スタイルを選ぶ'].option[0].value
            //     }
            // },
            style_selected1_name : function(value){
                this.message = ''
                this.atomaku_style_selected = ''
                this.atomaku_number = ''
                this.$store.commit('updateAtomakuItemNumber', '')
            },
            style_selected2_id : function(value){
                if(
                    this.$store.state.step2_data.style_selected2_id === '' ||
                    this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2 !== 'ローマンシェード ツイン'
                ){
                    this.message = ''
                    this.atomaku_style_selected = ''
                    this.atomaku_number = ''
                    this.$store.commit('updateAtomakuItemNumber', '')
                }
            },
            // atomaku_error_message : function(value){
            //     if(this.$store.state.atomaku_error_message === 'ファイル読み込みエラー'){
            //         this.message = '後幕非対応品番です'
            //     }
            // }
        },
        computed: {
            atomaku_options:{
              get : function(){
                  let options = []
                  let select_data= this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕スタイルを選ぶ'].option
                  let style_data = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕スタイルデータ'].option
                  let code_data = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕コード'].option
                  for(let i in this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['後幕スタイルデータ'].option){
                      options[i] = {}
                      options[i]['text']  = select_data[i].text
                      options[i]['value'] = style_data[i].value
                      options[i]['code']  = code_data[i].value
                  }
                  return options
              }
            },
            style_selected: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_id
                },
                set: function (value) {
                    this.$store.commit('updateStyleSelected2', value)
                    //this.$store.dispatch('priceCheck')
                }
            },
            atomaku_style_selected: {
                get: function () {
                    return this.$store.state.step3_data.atomaku_style
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'atomaku_style', value:value})
                    //this.$store.dispatch('priceAtomakuCheck')
                }
            },
            atomaku_error_message: {
                get: function () {
                    return this.$store.state.atomaku_error_message
                },
            },
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            style_selected2_id: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_id
                },
            },
            item_data:{
                get: function () {
                    if(this.$store.state.xlsx_data.item_data && this.atomaku_number !=='' && typeof(this.$store.state.xlsx_data.item_data['FF'+this.atomaku_number]) !== 'undefined'){
                        return this.$store.state.xlsx_data.item_data['FF'+this.atomaku_number]
                    }
                    return ''
                },
            }
        },
        methods:{
            /**
             * 対応不可理由の更新処理
             * @param style_name
             * @param style_result
             */
            no_select_rule : function(style_name,style_result){
                if(style_result[style_name]=='×'){
                    const item_num = this.$store.state.step1_data.item_number
                    const no_select_data = this.$store.state.xlsx_data.no_select_result['FF'+item_num]
                    //対応不可理由の更新
                    this.$store.commit('updateNoSelectResult', no_select_data[style_name])
                    this.showModal()
                }
            },
            no_atomaku_select_rule : function(style_name,style_result){
                if(this.$store.state.xlsx_data.item_data['FF'+this.atomaku_number] && style_result[style_name]=='×'){
                    const item_num = this.atomaku_number
                    const no_select_data = this.$store.state.xlsx_data.no_select_result['FF'+item_num]
                    //対応不可理由の更新
                    this.$store.commit('updateNoSelectResult', no_select_data[style_name])
                    this.showModal()
                }
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-2', '#btnShow')
            },
            load_svg: function(_file_name){
                //console.log(_file_name)
                const req = new XMLHttpRequest()
                req.open('GET', './assets/images/'+_file_name, true)
                req.responseType = 'text'
                const scope = this

                //ローディングをつける　TODO
                req.onload = function () {
                    if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                        return false
                    }
                    //データを処理
                    //document.getElementById("living").appendChild( req.responseXML )
                    scope.svg_html[_file_name] = req.responseText
                }
                req.onerror = function() {
                    return false
                }
                req.send();
            },
            /**
             * 品番データがあるかチェック
             */
            checkItemNumber : function(get_id){
                if(this.atomaku_number === ''){
                    return false
                }
                const xlsx_data = this.$store.state.xlsx_data
                if (this.isset(xlsx_data.item_data) && xlsx_data.item_data['FF'+this.atomaku_number]) {
                    this.message = '品番データがあります'
                    this.$store.commit('updateAtomakuItemNumber', this.atomaku_number)
                    this.$store.commit('updateAtomakuSearchData', xlsx_data.item_data['FF'+this.atomaku_number])
                } else {
                    this.message = '品番データが見つかりませんでした'
                    this.atomaku_style_selected = ''
                    this.$store.commit('updateOptionSelected', {name:'atomaku_style', value:''})
                    this.$store.commit('updateAtomakuItemNumber', '')
                    this.$store.dispatch('priceAtomakuCheck')
                }
            },
            /**
             *  値の有無をチェック
             *  phpのisset()に相当
             *  @param  data    値
             *  @return         true / false
             *
             */
            isset : function(data){
                if(data === "" || data === null || data === undefined){
                    return false;
                }else{
                    return true;
                }
            },
            /**
             * エンターキー対応
             * @param event
             */
            trigger: function(event) {
                // 日本語入力中のEnterキー操作は無効にする
                if (event.keyCode !== 13) return
                // 実行したい処理
                this.checkItemNumber()
            }
        }
    }
</script>

<style scoped>
    .accordion_onoff{
        display: none;
    }
</style>